import type { FC } from 'react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { Disclosure } from '@headlessui/react'
import { classNames } from '@g4g/utils/src/react/class-names'

const MobileDisclosure: FC<{
  title: string
  defaultOpen?: boolean
  children?: React.ReactNode
  'data-cy'?: string
}> = ({ title, defaultOpen, children, 'data-cy': dataCy }) => (
  <Disclosure defaultOpen={defaultOpen}>
    {({ open }) => (
      <>
        <Disclosure.Button data-cy={dataCy} className="flex justify-between w-full py-2 text-white">
          <span className="text-lg font-normal">{title}</span>
          <ChevronDownIcon className={classNames('h-5 w-5', open ? 'rotate-180 transform' : '')} />
        </Disclosure.Button>
        <Disclosure.Panel className="pb-4 border-b border-gray-600/20">{children}</Disclosure.Panel>
      </>
    )}
  </Disclosure>
)

export default MobileDisclosure
